<script>
    import API from "../../../../class/API";
    import { t } from "../../../../i18n";

    export let data = {};

    let api = API('quotation.map', {id: data.qid}, {
        decoder: p=>p.blob(),
        parser: p=>p,
    });
</script>


{#await api}
    <div>{$t('map.loading')}</div>

{:then data}
    <img src={URL.createObjectURL(data)} alt={$t('map.alt')} title={$t('map.title')} style="max-width: 100%; border: 1px solid #745c1e63; border-radius: 4px;" />

{:catch error}
    <p data-why={error}>{$t('map.error')}</p>

{/await}